"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderEnum = void 0;
var OrderEnum;
(function (OrderEnum) {
    OrderEnum["ASC"] = "ASC";
    OrderEnum["DESC"] = "DESC";
})(OrderEnum = exports.OrderEnum || (exports.OrderEnum = {}));
//# sourceMappingURL=order-enum.js.map